export default __webpack_public_path__ + "static/media/arrow-down.b468097b.svg";